// extracted by mini-css-extract-plugin
export default {"wrapper":"webpack-components-shared-DocumentViewer-DocumentViewer-module__wrapper","selectWrapper":"webpack-components-shared-DocumentViewer-DocumentViewer-module__selectWrapper"};